import { useSyncExternalStore } from 'react'
import { getAccessToken, isBootstrapped, subscribeAuth } from './auth-store'

export function useAccessToken(): string | null {
  return useSyncExternalStore(subscribeAuth, getAccessToken, () => null)
}

export function useBootstrapped(): boolean {
  return useSyncExternalStore(subscribeAuth, isBootstrapped, () => false)
}
